import { render } from "./Register.vue?vue&type=template&id=2eb08f08&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=2eb08f08&lang=scss&scoped=true"

import exportComponent from "/var/lib/docker/jenkins_home/workspace/spider-web-gp-tools-s3-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb08f08"]])

export default __exports__